import { select } from 'redux-most';
import { switchMap, fromFuture, ignoreElements } from 'most-adjunct';
import * as mostc from '../../../crosscutting/mostc';
import * as most from 'most';
import * as r from 'ramda';
import * as signals from '../../signals';
import * as messages from '../../../domain/messages';
import { stopSubmit } from 'redux-form';
import uuid from 'uuid/v4';
import axios from 'axios';

function createOptInFlow(saveInteraction, values, source, actions) {
  const categoryKeys = r.pipe(
    r.pick([
    'analytics',
    'support',
    'marketing',
    ]),
  )(values);

  if(source === 'ribbon' || source === 'modal') {
    axios({
      method: 'post',
      url: 'https://www.google-analytics.com/collect',
      headers: {
        'Content-Type': 'text/plain',
      },
      data: `v=1&t=event&tid=${CONFIG.analytics.tracker}&cid=${uuid()}&aip=1&ec=Consent&ea=accept&el=${source}`,
    });
  }

  const after = r.pipe(
    select(messages.OPTED_IN),
    switchMap(() => {
      const savingInteraction = saveInteraction(365);

      return most.merge(
        most.of(stopSubmit('privacyRibbon')),
        r.pipe(
          fromFuture,
          ignoreElements,
        )(savingInteraction),
      );
    }),
  )(actions);

  return most.merge(
    after,
    most.of(signals.optIn(categoryKeys)),
  );
}

function createOptOutFlow(saveInteraction, values, source, actions) {
  if(source === 'ribbon'  || source === 'modal') {
    axios({
      method: 'post',
      url: 'https://www.google-analytics.com/collect',
      headers: {
        'Content-Type': 'text/plain',
      },
      data: `v=1&t=event&tid=${CONFIG.analytics.tracker}&cid=${uuid()}&aip=1&ec=Consent&ea=decline&el=${source}`,
    });
  }

  const after = r.pipe(
    select(messages.OPTED_OUT),
    switchMap(() => {
      const savingInteraction = saveInteraction(90);


      return most.merge(
        most.of(stopSubmit('privacyRibbon')),
        r.pipe(
          fromFuture,
          ignoreElements,
        )(savingInteraction),
      );
    }),
  )(actions);

  return most.merge(
    after,
    most.of(signals.optOut()),
  );
}

const createOptFlow = r.pipe(
  (...args) => args,
  r.ifElse(
    r.pathEq([1, 'submit'], 'accept'),
    r.apply(createOptInFlow),
    r.apply(createOptOutFlow),
  ),
);

r.ifElse(
  r.propEq(''),
);

export default function createSubmitFormEpic(
  saveInteraction,
) {
  return (actions) => r.pipe(
    select(signals.SUBMIT_FORM),
    switchMap((action) => {
      const {
        values,
        source,
      } = action.payload;

      const optFlow = createOptFlow(saveInteraction, values, source, actions);

      return optFlow;
    }),
  )(actions);
}



// WEBPACK FOOTER //
// ./src/application/epics/privacy/form.js